<div class="container-fluid">
    <div class="row">
        <div class="col-12">
            <h4>Preguntas</h4>
        </div>
    </div>
    <div class="row" *ngFor="let preguntaHija of subPreguntas">
        <div class="col flex-grow-0 my-auto">
            <h3 class="mb-0 pe-1 mas-chico" [style.color]="colores[obtenerId(pregunta.Tipo)]"
                [attr.item-id]="!accesoPublico ? preguntaHija.Id : null" container="body"
                ngbTooltip="{{!accesoPublico ? preguntaHija.Id : null}}">
                {{ preguntaHija.IdRelativo }}
            </h3>
        </div>
        <div class="col flex-grow-0 my-auto">
            <div class="form-check form-switch">
                <input type="checkbox" class="form-check-input" [(ngModel)]="preguntaHija.Opcional"
                       [id]="'opcional-' + (!accesoPublico ? preguntaHija.Id : null)" [disabled]="accesoPublico">
                <label class="form-check-label" [for]="'opcional-' + (!accesoPublico ? preguntaHija.Id : null)">Opcional</label>
            </div>
        </div>
        <div class="col">
            <div class="row">
                <div class="col d-flex align-items-center">
                    <input type="text" class="form-control no-borders" [(ngModel)]="preguntaHija.Texto"
                        [disabled]="accesoPublico">
                </div>
                <div class="col flex-grow-1">
                    <div class="row">
                        <div class="col-4">
                            <div class="mb-3">
                                <label class="form-label" for="desde">Desde</label>
                                <input type="number" id="desde" class="form-control" [(ngModel)]="preguntaHija.Minimo"
                                    [disabled]="accesoPublico">
                            </div>
                        </div>
                        <div class="col-4">
                            <div class="mb-3">
                                <label class="form-label" for="hasta">Hasta</label>
                                <input type="number" id="hasta" class="form-control" [(ngModel)]="preguntaHija.Maximo"
                                    [disabled]="accesoPublico">
                            </div>
                        </div>
                        <div class="col-4">
                            <div class="mb-3">
                                <label class="form-label" for="incremento">Incremento</label>
                                <input type="number" id="incremento" class="form-control" [(ngModel)]="preguntaHija.Paso"
                                    [disabled]="accesoPublico">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col flex-grow-0 text-end my-auto seleccionable" *ngIf="!accesoPublico"
            (click)="abrirEditorCondiciones(preguntaHija)">
            <span>
                <i class="fa-regular fa-list-check fa-xl"></i>
            </span>
        </div>
        <div class="col flex-grow-0 text-end my-auto" [class.seleccionable]="borrarPreguntaCmd.puedeEjecutarse"
            (click)="clickBorrarPregunta(preguntaHija)" *ngIf="!accesoPublico">
            <span><i class="fa-regular fa-trash-can fa-xl"></i></span>
        </div>
    </div>
    <div class="row" *ngIf="!accesoPublico">
        <div class="col flex-grow-0 h3 mb-0 pe-0">+</div>
        <div class="col mb-3">
            <input type="text" placeholder="Agregue una pregunta..." class="form-control no-borders"
                [(ngModel)]="textoPregunta" (keyup.enter)="agregarPreguntaCmd.ejecutar()"
                [disabled]="!agregarPreguntaCmd.puedeEjecutarse">
        </div>
    </div>
</div>
